// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Hwb","text":"az_Iwb","pulse":"az_Jwb","wave":"az_Kwb"};